import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataPdf = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.914 1.5a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h9a.75.75 0 00.75-.75v-9h-3a2.25 2.25 0 01-2.25-2.25v-3h-4.5zm6 1.06l2.69 2.69h-1.94a.75.75 0 01-.75-.75V2.56zm-8.25-.31A2.25 2.25 0 013.914 0h5.25c.198 0 .39.079.53.22l5.25 5.25c.14.14.22.331.22.53v9.75a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25V2.25z" })
});
export default SvgDataPdf;
